import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ConstructionReworkOrdersService } from '../services/constructionReworkOrders.service';
import type { ConstructionReworkOrder } from '../types/construction-rework.types';
import { toast } from 'sonner';

export function useConstructionReworkDetail(id?: string) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['construction-rework-orders', 'detail', id],
    queryFn: () => ConstructionReworkOrdersService.getReworkDetail(id!),
    enabled: !!id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<ConstructionReworkOrder>) => ConstructionReworkOrdersService.updateRework(id!, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['construction-rework-orders'] });
      queryClient.invalidateQueries({ queryKey: ['construction-rework-orders', 'detail', id] });
      toast.success('Cập nhật lệnh sửa lỗi thành công');
    },
  });

  return {
    reworkOrder: query.data,
    isLoading: query.isLoading,
    updateRework: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
}
